import { createBrowserHistory } from 'history';

// configure, create, and export the project's history instance
export default createBrowserHistory();



// WEBPACK FOOTER //
// ./src/history.js